import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.633 22.118a.971.971 0 0 1-.971.973H10.414a.972.972 0 0 1-.972-.973V12.07c2.949-.01 9.827-.01 13.191 0v10.05ZM13.609 6.915a.225.225 0 0 1-.097.301.225.225 0 0 1-.301-.097l-1.422-2.771a.224.224 0 0 1 .4-.204l1.42 2.77Zm5.179.118a.222.222 0 0 1-.307.08.221.221 0 0 1-.08-.304l1.557-2.697a.222.222 0 0 1 .305-.081.222.222 0 0 1 .082.304l-1.557 2.698Zm7.279 12.358a1.416 1.416 0 1 1-2.834 0v-6.197c0-.783.634-1.416 1.418-1.416.782 0 1.416.633 1.416 1.416v6.197Zm-17.234 0a1.417 1.417 0 0 1-2.833 0v-6.197a1.416 1.416 0 1 1 2.833 0v6.197Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 26.485a1.417 1.417 0 0 1-2.833 0v-6.197a1.417 1.417 0 1 1 2.833 0v6.197Zm4.913 0a1.417 1.417 0 0 1-2.834 0v-6.197a1.418 1.418 0 0 1 2.834 0v6.197ZM16.038 5.447c-3.445 0-6.282 2.621-6.66 5.991h13.32c-.378-3.37-3.213-5.991-6.66-5.991Zm-3.005 3.632a.554.554 0 1 1-.004-1.107.554.554 0 0 1 .004 1.107Zm6.022 0a.554.554 0 1 1-.002-1.107.554.554 0 0 1 .002 1.107Z",
    fill: "currentColor"
  }));
};

var SvgAndroid = styled(SvgComponent).withConfig({
  displayName: "Android__SvgAndroid",
  componentId: "sc-ub6rhs-0"
})(["", " ", ""], size, color);
export default SvgAndroid;